import { computed, inject, Pipe, PipeTransform } from '@angular/core';
import { ProfileState } from '@app/layout/common/profile/state/profile.state';
import { SealNavigationItem } from '@shipsfocus/seal';

@Pipe({
  name: 'navigationVessel'
})
export class NavigationVesselPipe implements PipeTransform {
  protected readonly profileState: ProfileState = inject(ProfileState);

  public transform(items: SealNavigationItem[]): SealNavigationItem[] {
    return computed(() => {
      const isVessel = this.profileState.isVessel();

      if (!isVessel) {
        return items;
      }

      return this.append(items, 'ship-interface.ship-interface');
    })();
  }

  public append(items: SealNavigationItem[], id: string): SealNavigationItem[] {
    const index = items.findIndex((item) => item.id === id);

    if (index === -1) {
      return items;
    }

    const children = items[index].children ?? [];

    if (!children.length) {
      return items;
    }

    return [...items.slice(0, index), ...children, ...items.slice(index + 1)];
  }
}
